import API from "@codex/utils/services";
export var getSurvayData = function () {
    return API.auth.post('survey/start').then(function (res) { return res.data; });
};
export var saveSurvayData = function (data) { return function () {
    return API.auth.post('survey/answers', data).then(function (res) { return res.data; });
}; };



//////////////////
// WEBPACK FOOTER
// ./src/pages/Survay/ducks/api.ts
// module id = 695
// module chunks = 0